define('core/helper/LoadCss',[
	'jQuery',
	'core/helper/LocalStorageCss',
], function ($, LocalStorageCss) {
	'use strict';

	var module = {
		_loadCSS: false,
		init: function ($element, options) {
			options = $.extend(true, {}, $element.data(), options);

			var moduleNames = $.makeArray(options.moduleNames || options.moduleName);
			moduleNames.forEach(function(moduleName) {
				LocalStorageCss.loadModuleCSS(moduleNames);
			});
		},
	};

	return module;
});

